import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Checkbox as MuiCheckbox, CheckboxProps, Box } from "@mui/material";

type ICheckboxProps = {
  name: string;
  label: string;
  containerSx?: object;
} & CheckboxProps;

export const CheckBox: React.FC<ICheckboxProps> = ({ name, label,containerSx , ...otherProps }) => {

  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field: { value, onChange } }) => (
        <Box sx={containerSx} style={{ display: "flex", alignItems: "center" }}>
          <MuiCheckbox {...otherProps} checked={value} defaultChecked={false} onChange={onChange} />
          <label>{ label }</label>
        </Box>
      )
      }
    />
  );
}